const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "click_id",
  "referrer",
];

const AFFILIATE_PARAMS_KEY = "affiliateParams";

export function captureAffiliateParams() {
  if (typeof window === "undefined") return;

  const urlParams = new URLSearchParams(window.location.search);
  const affiliateData: Record<string, string> = {};

  for (const key of UTM_KEYS) {
    const value = urlParams.get(key);
    if (value) {
      affiliateData[key] = value;
    }
  }

  if (Object.keys(affiliateData).length > 0) {
    sessionStorage.setItem(AFFILIATE_PARAMS_KEY, JSON.stringify(affiliateData));
  }
}

export function getAffiliateParams() {
  if (typeof window === "undefined") return null;

  const stored = sessionStorage.getItem(AFFILIATE_PARAMS_KEY);
  return stored ? JSON.parse(stored) : null;
}

export function clearAffiliateParams() {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(AFFILIATE_PARAMS_KEY);
  }
}
